import React, { useState, useEffect, useCallback } from "react";
import { globalVars } from "../global/GlobalVars.js";
import * as websocket from "./communication.js";

//========================================================================
// Wert aus globalVars auslesen
const readRcvValue = (variable) => {
  // Teile den Pfad in seine Komponenten
  const ids = variable.split(".").map(String);

  // Rekursive Hilfsfunktion zum Durchsuchen der Struktur
  function recursiveSearch(items, index) {
    if (index >= ids.length) return null; // Basisfall, wenn der Index den Pfad übersteigt
    const item = items.find((item) => item.id === ids[index]);
    if (item) {
      if (index === ids.length - 1) return item; // Rückgabe, wenn der letzte Index erreicht ist
      if (Array.isArray(item.value)) {
        // Rekursiver Aufruf, wenn `value` ein Array ist
        return recursiveSearch(item.value, index + 1);
      }
    }
    return null;
  }

  // Starte die Suche mit dem ersten Index
  const result = recursiveSearch(globalVars.rcvValues, 0);
  if (result) {
    return result;
  } else {
    // Rückgabe eines Fehlerobjekts, wenn das gesuchte Objekt nicht gefunden wird
    return {
      value: "error",
      typ: "text",
      name: ["zugewiesene Variable existiert nicht"],
      unit: "text",
      decimalPoints: 0,
      setpoint: false,
    };
  }
};

//========================================================================
// Wert in globalVars schreiben
function updateRcvValue(variable, newValue) {
  let newRcvValues = [...globalVars.rcvValues]; // Erstelle eine flache Kopie von rcvValues

  // Teile den Pfad in seine Komponenten
  const ids = variable.split(".").map(String);

  // Rekursive Hilfsfunktion zum Durchsuchen und Aktualisieren der Struktur
  function recursiveUpdate(items, index) {
    if (index >= ids.length) return false; // Basisfall, wenn der Index den Pfad übersteigt
    const item = items.find((item) => item.id === ids[index]);
    if (item) {
      if (index === ids.length - 1) {
        item.value = newValue; // Setze den neuen Wert, wenn der letzte Index erreicht ist
        return true;
      }
      if (Array.isArray(item.value)) {
        // Rekursiver Aufruf, wenn `value` ein Array ist
        return recursiveUpdate(item.value, index + 1);
      }
    }
    return false;
  }

  // Starte das Update mit dem ersten Index
  const result = recursiveUpdate(newRcvValues, 0);
  if (result) {
    globalVars.setRcvValues(newRcvValues); // Aktualisiere rcvValues global über setRcvValues
    return true;
  } else {
    // Rückgabe eines Fehlers, wenn das zu aktualisierende Objekt nicht gefunden wird
    return false;
  }
}

//========================================================================
// Wert an Server senden
function writeValue(variable, newValue, oldValue) {
  let user = "undefined user";
  if (globalVars.auth.name) {
    user = globalVars.auth.name;
  }

  websocket.sendData(globalVars.ws, variable, newValue, oldValue, user);
}

//========================================================================
// Funktionen exportieren
export { readRcvValue, updateRcvValue, writeValue };
